import React, { useEffect } from "react";
import parser from "papaparse";
import { functionService } from "../../lib/functions";
import { useState } from "react";
import Sidemenu from "../sidemenu";
import csvDownload from "json-to-csv-export";
import { Button } from "antd";
import moment from "moment";

const CandidateLaterals = () => {
  const [message, setMessage] = useState("");
  const [masterSkills, setMasterSkills] = useState();
  const [errorEntriesList, setErrorEntriesList] = useState([]);
  const [errorMessage, setErrorMessage] = useState([]);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [wrongCsvCheck, setWrongCsv] = useState(false);
  const [duplicateEntries, setDuplicateEntries] = useState(false);
  var checkDuplicateEnteries = new Set();

  const getMasterSkills = async () => {
    const { response } = await functionService.get("userupdate/masterskills");
    setMasterSkills(response?.data?.data?.masterSkillsList);
  };
  useEffect(() => {
    getMasterSkills();
  }, []);

  const uploadData = async (results) => {
    var payload = {},
      payloadArr = [];
    var skillupdatepayload = {};
    var skillpayload = [],
      skillPayloadArr = [];
    try {
      setLoading(true);
      for (let i = 0; i < results?.data?.length; i++) {
        let item = results?.data[i];

        try {
          payload["email"] = item["Email"];
          payload["date_called"] = item["Called Date"];
          payload["caller_name"] = item["Caller Detail"];
          payload["candidate_name"] = item["Candidate Name"];
          payload["available_on"] = isNaN(parseInt(item["Notice Period (In days)"])) ? null : moment()
          .add(item["Notice Period (In days)"], "days")
          .format();
          payload["current_company"] = item["Current Company"];
          payload["current_ctc"] = item["Current Ctc"]?item["Current Ctc"]:null;
          payload["current_job_role"] = item["Current Job Role"];
          payload["current_location"] = item["Current Location"];
          payload["serving_notice"] = item["Currently on notice"];
          payload["notice_period_min"] = item["Notice Period (In days)"]?item["Notice Period (In days)"]:null;
          payload["degree_name"] = item["Degree"];
          payload["expected_ctc"] = item["Expected ctc"]?item["Expected ctc"]:null;
          // payload["is_assessed"] = item["Is assessed"];
          // payload["is_coffeee_user"] = item["Is user"];
          payload["negotiable"] = item["Negotiable"];
          payload["phone"] = item["Phone Number"]?item["Phone Number"]:null;
          payload["preferred_location"] = item["Prefrered Location"]?item["Prefrered Location"].split(','):[];
          payload["primary_skill"] = item["Primary Skill"];
          payload["remarks"] = item["Remarks"];
          payload["resume"] = item["Resume"];
          payload["source"] = item["Source"];
          payload["university_name"] = item["University"];
          payload["notice_period_max"] = item["Upto (Days)"]?item["Upto (Days)"]:null;
          payload["year_of_exp"] = item["Year of Exp"]?item["Year of Exp"]:null;
          payload["year_of_grad"] = item["Year of graduation"];
          if(item["Other Skill 1"]!=''){
            skillpayload.push(item["Other Skill 1"] );

          }if(item["Other Skill 2"]!=''){
            skillpayload.push(item["Other Skill 2"] );

          }
          payload["skills"] = skillpayload;

          payloadArr.push(payload);

          skillpayload = [];
          payload = {};
        } catch (error) {
          setMessage(error);
        }
      }

      // console.log('====================>',payloadArr)

      const { status } = await functionService.post("laterals", {
        payloadArr: payloadArr,
      });

      // const { status: skillStatus } = await functionService.post(
      //   "userupdate/skill",
      //   { skills: skillPayloadArr }
      // );
      setSuccess(status );
      // });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setMessage("something went wrong");
    }
  };

  const handleFile = (e) => {
    setMessage("");
    setSuccess(false);
    setLoading(false);
    setWrongCsv(false);
    checkDuplicateEnteries = new Set();
    setDuplicateEntries(false)
    // errorCounter=0
    try {
      setErrorMessage([]);
      setErrorEntriesList([]);
      if (e.target.files !== undefined) {
        setLoading(true);
        // setFileName(e.target.files[0]?.name);
        parser.parse(e.target?.files[0], {
          header: true,
          skipEmptyLines: true,
          complete: function (results) {
            console.log(results.data);
            const entriesWithError = [];
            const entriesWithErrorMessage = [];
            var duplicateEntriesAvailable = false;
            results &&
              results.data.map((item) => {
                try {
                  checkDuplicateEnteries.add(item["Email"]);

                  var payload = {};
                  var skillupdatepayload = {};
                  var skillpayload = [];

                  // console.log('====================>', (isNaN(parseInt(item["Notice Period (In days)"]))),  item["Notice Period (In days)"])
                  // console.log('====================>',typeof parseInt(item["Notice Period (In days)"]),  isNaN(parseInt(item["Notice Period (In days)"])) ? null : moment()
                  // .add(item["Notice Period (In days)"], "days")
                  // .format())

                  payload["email"] = item["Email"];
                  payload["date_called"] = item["Called Date"];
                  payload["caller_name"] = item["Caller Detail"];
                  payload["candidate_name"] = item["Candidate Name"];
                  payload["available_on"] = isNaN(parseInt(item["Notice Period (In days)"])) ? null : moment()
                    .add(item["Notice Period (In days)"], "days")
                    .format();
                  payload["current_company"] = item["Current Company"];
                  payload["current_ctc"] = item["Current Ctc"];
                  payload["current_job_role"] = item["Current Job Role"];
                  payload["current_location"] = item["Current Location"];
                  payload["serving_notice"] = item["Currently on notice"];
                  payload["notice_period_min"] = item["Notice Period (In days)"];
                  payload["degree_name"] = item["Degree"];
                  payload["expected_ctc"] = item["Expected ctc"];
                  // payload["is_assessed"] = item["Is assessed"];
                  // payload["is_coffeee_user"] = item["Is user"];
                  payload["negotiable"] = item["Negotiable"];
                  payload["phone"] = item["Phone Number"];
                  payload["preferred_location"] = item["Prefrered Location"];
                  payload["primary_skill"] = item["Primary Skill"];
                  payload["remarks"] = item["Remarks"];
                  payload["resume"] = item["Resume"];
                  payload["source"] = item["Source"];
                  payload["university_name"] = item["University"];
                  payload["notice_period_max"] = item["Upto (Days)"];
                  payload["year_of_exp"] = item["Year of Exp"];
                  payload["year_of_grad"] = item["Year of graduation"];
                    skillpayload.push(
                      item["Other Skill 1"]
                    );


                  skillpayload.push(
                    item["Other Skill 2"]
                  );
                  payload["skills"] = skillpayload;
                  const {
                    email,
                    date_called,
                    caller_name,
                    candidate_name,
                    available_on,
                    current_company,
                    serving_notice,
                    notice_period_min,
                    notice_period_max,
                    degree_name,
                    expected_ctc,
                    negotiable,
                    phone,
                    preferred_location,
                    primary_skill,
                    remarks,
                    resume,
                    source,
                    university_name,
                    year_of_exp,
                    year_of_grad,
                    skills,
                  } = payload;
                  var flag1 = 0,
                    flag2 = 0,
                    flag3 = 0;

                    // console.log(payload)


                  // if (
                  //   item["Primary Skill"] !== "" &&
                  //   item["Primary Skill"] !== undefined
                  // ) {
                  //   masterSkills.forEach((val) => {
                  //     if (item["Primary Skill"] === val.name) {
                  //       flag3 = 1;
                  //     }
                  //   });
                  // }


                  // if (
                  //   item["Primary Skill"] !== "" &&
                  //   !flag3 &&
                  //   item["Primary Skill"] !== undefined
                  // ) {
                  //   entriesWithError.push({
                  //     email,
                  //     date_called,
                  //     caller_name,
                  //     candidate_name,
                  //     available_on,
                  //     current_company,
                  //     serving_notice,
                  //     notice_period_min,
                  //     notice_period_max,
                  //     degree_name,
                  //     expected_ctc,
                  //     negotiable,
                  //     phone,
                  //     preferred_location,
                  //     primary_skill,
                  //     remarks,
                  //     resume,
                  //     source,
                  //     university_name,
                  //     year_of_exp,
                  //     year_of_grad,
                  //     skill1: skillpayload[0],
                  //     skill2: skillpayload[1],
                  //     check: "Primary Skill name is not correct.",
                  //   });
                  //   entriesWithErrorMessage.push({
                  //     email,
                  //     date_called,
                  //     caller_name,
                  //     candidate_name,
                  //     available_on,
                  //     current_company,
                  //     serving_notice,
                  //     notice_period_min,
                  //     notice_period_max,
                  //     degree_name,
                  //     expected_ctc,
                  //     negotiable,
                  //     phone,
                  //     preferred_location,
                  //     primary_skill,
                  //     remarks,
                  //     resume,
                  //     source,
                  //     university_name,
                  //     year_of_exp,
                  //     year_of_grad,
                  //     skill1: skillpayload[0],
                  //     skill2: skillpayload[1],
                  //     check: "Primary Skill name is not correct.",
                  //   });
                  //   // setErrorMessage("Primary Skill is not correct.")
                  //   // errorCounter++;
                  // } else {
                    entriesWithError.push({
                      email,
                      date_called,
                      caller_name,
                      candidate_name,
                      available_on,
                      current_company,
                      serving_notice,
                      notice_period_min,
                      notice_period_max,
                      degree_name,
                      expected_ctc,
                      negotiable,
                      phone,
                      preferred_location,
                      primary_skill,
                      remarks,
                      resume,
                      source,
                      university_name,
                      year_of_exp,
                      year_of_grad,
                      skill1: skillpayload[0],
                      skill2: skillpayload[1],
                      check: "Passed",
                    });
                  // }
                } catch (error) {
                  setMessage(error);
                }
              });
            setErrorMessage(entriesWithErrorMessage);
            setErrorEntriesList(entriesWithError);
            if (checkDuplicateEnteries.size != results.data.length) {
              duplicateEntriesAvailable = true;
              setDuplicateEntries(duplicateEntriesAvailable);
              setMessage("There are duplicate entries(Emails) available");
            }
            // console.log(errorEntriesList);
            else if (
              entriesWithErrorMessage?.length > 0 ||
              errorMessage?.length > 0
            ) {
              setMessage(
                "There is some error with the uploaded file. Please download the error file, update it and upload it again."
              );
            } else {
              if (!wrongCsvCheck) {
                // console.log("CALLEd");
                uploadData(results);
              }
            }
          },
        });
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);

      setMessage(err["message"]);
    }
  };

  const downloadErrorFile = () => {
    console.log(errorEntriesList);
    const dataToConvert = {
      data: errorEntriesList.map(
        ({
          email,
          candidate_name,
          date_called,
          caller_name,
          // available_on,
          current_company,
          serving_notice,
          notice_period_min,
          notice_period_max,
          degree_name,
          expected_ctc,
          negotiable,
          phone,
          preferred_location,
          primary_skill,
          remarks,
          resume,
          source,
          university_name,
          year_of_exp,
          year_of_grad,
          skill1,
          skill2,
          check,
        }) => {
          return {
            email,
            candidate_name,
            date_called,
            caller_name,
            // available_on,
            current_company,
            serving_notice,
            notice_period_min,
            notice_period_max,
            degree_name,
            expected_ctc,
            negotiable,
            phone,
            preferred_location,
            primary_skill,
            remarks,
            resume,
            source,
            university_name,
            year_of_exp,
            year_of_grad,
            skill1,
            skill2,
            check,
          };
        }
      ),
      filename: "error_file",
      delimiter: ",",
      headers: [
        "Email",
        "Candidate Name",
        "Called Date",
        "Caller Detail",
        "Current Company",
        "Currently on notice",
        "Days",
        "Upto (Days)",
        "Degree",
        "Expected ctc",
        "Negotiable",
        "Phone Number",
        "Prefrered Location",
        "Primary Skill",
        "Remarks",
        "Resume",
        "Source",
        "University",
        "Year of Exp",
        "Year of Grad",
        "Other Skill 1",
        "Other Skill 2",
        "Error",
      ],
    };
    csvDownload(dataToConvert);
  };
  return (
    <div style={{ display: "flex" }}>
      {" "}
      <Sidemenu />
      <div style={{ padding: "100px", width: "100%" }}>
        <p style={{ fontWeight: "700", fontSize: "20px" }}>
          Candidate Laterals
        </p>
        <label
          for="upload"
          style={{
            border: "1px dashed grey",
            borderRadius: "10px",
            padding: "20px",
            background: "#F6FAFF",
            // width: "50%",
            marginBottom: "20px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <input
            onChange={handleFile}
            type="file"
            id="upload"
            // style={{ padding: "20px" }}
            hidden
            accept=".csv"
            onClick={(e) => {
              e.target.value = null;
            }}
          />
          <div
            style={{
              display: "Flex",
              flexDirection: "column",
              justifyContent: "flex-start",
            }}
          >
            <p
              style={{
                fontStyle: "normal",
                fontWeight: 700,
                fontSize: "14px",
                marginTop: "0px",
                color: "#1E2228",
              }}
            >
              {" "}
              Choose file to upload
            </p>
            <span
              style={{
                fontWeight: 400,
                fontSize: "12px",

                color: "#506D85",
              }}
            >
              {" "}
              File format : Excel
            </span>
          </div>
          <span>
            <img alt="" src="./upload.svg" style={{ marginRight: "10px" }} />
          </span>
        </label>
        {loading && (
          <p style={{ fontWeight: "700", margin: "15px 0" }}>UPDATING....</p>
        )}
        {wrongCsvCheck && (
          <p style={{ fontWeight: "700", color: "red", margin: "15px 0" }}>
            {message}
          </p>
        )}
        {/* {console.log(errorCounter)} */}
        {duplicateEntries && (
          <p style={{ fontWeight: "700", color: "red", margin: "15px 0" }}>
            {message}
          </p>
        )}
        {!duplicateEntries && errorMessage?.length > 0 && (
          <p style={{ fontWeight: "700", color: "red", margin: "15px 0" }}>
            {message}
          </p>
        )}
        {!duplicateEntries && errorMessage?.length > 0 && (
          <Button
            type="primary"
            onClick={() => {
              downloadErrorFile();
            }}
            style={{
              borderRadius: "6px",
              marginRight: "10px",
              width: "200px",
            }}
            danger
          >
            Download file with errors
          </Button>
        )}
        {success&&<p style={{color:"green",fontWeight:"700",margin: "15px 0" }}>Successfully added</p>}
      </div>
    </div>
  );
};

export default CandidateLaterals;
